import {autoPlacement, computePosition, offset} from "@floating-ui/dom";

const TOOLTIP_OFFSET = 10;

/**
 * Initializes floating tooltips for elements with data-floating-tooltip attribute
 * @param {HTMLElement} parent - Parent element to search within
 */
export function init(parent) {
    const tooltip = document.querySelector('#default-tooltip');
    if (!tooltip) return;

    hideTooltip(tooltip);
    parent.querySelectorAll('[data-floating-tooltip]').forEach((trigger) => {
        if (!trigger.tooltipLoaded) {
            trigger.tooltipLoaded = true;
            trigger.addEventListener('mouseenter', () => {
                showTooltip(trigger, tooltip);
            });

            trigger.addEventListener('mouseleave', () => {
                hideTooltip(tooltip);
            });
        }
    });
}

/**
 * Shows and positions the tooltip
 */
async function showTooltip(trigger, tooltip) {
    setTooltipContent(trigger, tooltip);

    tooltip.style.visibility = 'hidden';
    tooltip.style.opacity = '0';
    tooltip.style.display = 'block';

    const options = buildPositionOptions(trigger);
    const { x, y } = await computePosition(trigger, tooltip, options);

    positionTooltip(tooltip, x, y);

    tooltip.style.visibility = 'visible';
    tooltip.style.opacity = '1';
}

/**
 * Hides the tooltip
 */
function hideTooltip(tooltip) {
    tooltip.style.visibility = 'hidden';
    tooltip.style.opacity = '0';
}

/**
 * Builds positioning options for the tooltip
 */
function buildPositionOptions(trigger) {
    const options = {
        middleware: [offset(TOOLTIP_OFFSET)]
    };

    if (trigger.dataset.tooltipPosition) {
        options.placement = trigger.dataset.tooltipPosition;
    } else {
        options.middleware.push(autoPlacement());
    }

    return options;
}

/**
 * Sets tooltip content from trigger data attributes
 */
function setTooltipContent(trigger, tooltip) {
    if (trigger.dataset.tooltipTitle) {
        tooltip.innerText = trigger.dataset.tooltipTitle;
    } else if (trigger.dataset.tooltipHtml) {
        const sourceElement = document.querySelector(trigger.dataset.tooltipHtml);
        if (sourceElement) {
            tooltip.innerHTML = sourceElement.innerHTML;
        }
    }
}

/**
 * Positions the tooltip at the specified coordinates
 */
function positionTooltip(tooltip, x, y) {
    Object.assign(tooltip.style, {
        left: `${x}px`,
        top: `${y}px`
    });
}